export default "__VITE_ASSET__JJpiLzMU__"